import * as React from 'react';
import { Button } from 'omakase';
import { Fade } from '@material-ui/core';
import { IconMap } from '@tock/icons';
import { Theme, css } from '@emotion/react';

interface Props {
  onClick(event: React.MouseEvent<HTMLButtonElement>): void;
}

const buttonStyles = (theme: Theme) => css`
  position: fixed;
  bottom: env(safe-area-inset-bottom, 0);
  margin-bottom: ${theme.spacing(8)}px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: ${theme.zIndex.appBar};

  ${theme.breakpoints.up('md')} {
    display: none;
  }

  @media screen and (orientation: landscape) {
    display: none;
  }
`;

export const FloatingMapButton: React.FunctionComponent<Props> = ({ onClick }) => {
  return (
    <Fade timeout={100} in={true}>
      <Button
        css={buttonStyles}
        size="small"
        variant="highContrast"
        iconStart={<IconMap />}
        onClick={onClick}
      >
        Map
      </Button>
    </Fade>
  );
};

export default FloatingMapButton;
